/** Preserves a trailing decimal for incremental input and truncates excess fractional digits. */
export const sanitizeDecimalInput = (raw: string, maximumFractionDigits?: number): string => {
  const [whole, ...fractions] = raw.replace(/[^\d.]/g, '').split('.');
  const fraction = fractions.join('').slice(0, maximumFractionDigits);

  return fractions.length > 0 ? `${whole}.${fraction}` : whole;
};
